import clsx from 'clsx'
import { useTranslation } from 'react-i18next';
import { LanguageSelectItem } from './LanguageSelectItem/LanguageSelectItem';
import { TLangs } from '../../../translations/types';
import { StyledLanguageSelect } from './styles';

export const LanguageSelect = () => {
  return (
    <StyledLanguageSelect>
      <LanguageSelectItem lang='en' />
      /
      <LanguageSelectItem lang='ru'/>
    </StyledLanguageSelect>
  )
}
